<button class="countdown" (click)="tryEmitCallback()">
  {{ ppTranslationKey | ppTranslate }}
  <span class="countdown__resend"
    >{{ ppTranslationKeyPrimaryColor | ppTranslate }}

    @if (timeLeft > 0) {
      {{ 'countdown_timer' | ppTranslate: { time: timeLeft } }}
    }
  </span>
</button>
